import React, { Component } from 'react';
import RegisterValidate from './registerValidate';
import RegisterUser from './registerUser';
import RegisterEmail from './registerEmail';
import Loading from "../login/loading";

class RegisterBox extends Component {
	render() {
		const {register} = this.props;
		let content = this._actionPane(register.action);
		return (
			<div className="columns login-box">
				<div className="column">
					<div className="columns is-centered">
						<div className="column is-10">
							{register.isFetching ? <Loading message={register.status} /> : content}
						</div>
					</div>
				</div>

				<a className="login-box--notification" href="/version2017.html" target="_blank">
					Acceder a versión 2017 <i className="fa fa-external-link" />
				</a>
			</div>
		)
	}

	_actionPane = (action) => {
		switch (action) {
			case 'register_not_validate':
				return <RegisterUser {...this.props}/>
			case 'register_validate':
				return <RegisterEmail {...this.props}/>
			default :
				return <RegisterValidate {...this.props}/>
		}
	}
}

export default RegisterBox;


// WEBPACK FOOTER //
// ./src/elements/register/register.jsx